export const MOVE_EVENT = 1;
export const INSERT_ROLL_EVENT = 2;
export const DELETE_EVENT = 3;
export const DELETE_COMPOUND_EVENT = 4;
export const EDIT_RESOLUTION = 5;
export const EDIT_PATTERN = 6;
export const INSERT_EVENT = 7;
export const MOVE_ROLL_EVENT = 8;
export const PASTE_SELECTION = 9;
export const DELETE_SELECTION = 10;
export const DUPLICATE_SELECTION = 11;
export const MOVE_PIANO_ROLL_PATTERN = 12;
export const SPLIT_PIANO_ROLL_PATTERN = 13;
export const PASTE_PIANO_ROLL_PATTERN = 14;
export const DUPLICATE_PIANO_ROLL_PATTERN = 15;
export const RESIZE_PIANO_ROLL_PATTERN = 16;
